import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RequiredUserActionValidatorService } from './required-user-action-validator.service';
import { RequiredUserActionValidator } from './required-user-action-service';
import { PhotodocRequiredUserAction } from './required-user-actions/photodoc-required-user-action.service';
import { TourEachDayFormRequiredUserAction } from './required-user-actions/tour-each-day-form-required-user-action.service';
import { NeedsDynFormRequiredUserAction } from './required-user-actions/needs-dynform-required-user-action.service';

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [
    RequiredUserActionValidatorService,
    {
      provide: RequiredUserActionValidator,
      useClass: PhotodocRequiredUserAction,
      multi: true,
    },
    {
      provide: RequiredUserActionValidator,
      useClass: TourEachDayFormRequiredUserAction,
      multi: true,
    },
    {
      provide: RequiredUserActionValidator,
      useClass: NeedsDynFormRequiredUserAction,
      multi: true,
    },
  ],
})
export class RequiredUserActionValidatorModule {}
